import React, { useRef, useEffect, useState } from "react";
import Map, { Layer, Marker, Source } from "react-map-gl/mapbox";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { MAPBOX_ACCESS_TOKEN, MAPBOX_STYLES } from "config/mapConfig";
import { reverseGeocodeWithMapbox } from "api/map";
import { getMapboxPolygonCentroid } from "utils/commonUtils";
import locations from "../locations.json";

import "mapbox-gl/dist/mapbox-gl.css";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";

const MapboxDrawMap = ({ onLocationSelect, onLocationRemove }) => {
  const mapRef = useRef(null);
  const drawRef = useRef(null);
  const [mapLoad, setMapLoad] = useState(false);

  // Convert the GeoJSON data to a format Mapbox can use
  const geojsonData = {
    type: "FeatureCollection",
    features: locations.features,
  };

  // Define the layer style for locations
  const locationsLayerStyle = {
    id: "locations-layer",
    type: "fill",
    paint: {
      "fill-color": "#0074c1",
      "fill-opacity": 0.3,
      "fill-outline-color": "#0074c1",
    },
  };

  useEffect(() => {
    if (!mapRef.current) return;
    const map = mapRef.current.getMap();

    // Initialize Mapbox Draw
    drawRef.current = new MapboxDraw({
      displayControlsDefault: false,
      controls: {
        polygon: true,
        trash: true,
      },
      defaultMode: "draw_polygon",
    });

    map.addControl(drawRef.current);

    // Constrain draw to the location layer
    map.on("draw.create", async (e) => {
      const polygon = e.features[0];

      // Get the centroid of the drawn polygon
      const centroid = getMapboxPolygonCentroid(
        polygon.geometry.coordinates[0]
      );

      try {
        // Get location name using reverse geocoding
        const locationData = await reverseGeocodeWithMapbox(
          centroid[0],
          centroid[1]
        );

        const geoJsonData = {
          type: "FeatureCollection",
          properties: {
            NIL: locationData.suburb,
            City: locationData.city,
          },
          geometry: polygon.geometry,
        };

        onLocationSelect(geoJsonData);
      } catch (error) {
        console.error("Error getting location name:", error);
      }
    });

    map.on("draw.update", (e) => {
      console.log("updated polygon", e.features);
    });

    map.on("draw.delete", () => {
      if (onLocationRemove) {
        onLocationRemove();
      }
    });

    return () => {
      if (drawRef.current) {
        map.removeControl(drawRef.current);
      }
    };
  }, [mapLoad, onLocationSelect, onLocationRemove]);

  console.log("geojsonData", geojsonData);

  return (
    <>
      <Map
        ref={mapRef}
        mapboxAccessToken={MAPBOX_ACCESS_TOKEN}
        initialViewState={{
          longitude: 9.1824,
          latitude: 45.4685,
          zoom: 11,
        }}
        style={{ width: "100%", height: "100%" }}
        mapStyle={MAPBOX_STYLES.STREETS}
        scrollZoom={false}
        attributionControl={false}
        onLoad={() => setMapLoad(true)}
      >
        <Source id="locations-source" type="geojson" data={geojsonData}>
          <Layer {...locationsLayerStyle} />
        </Source>
      </Map>
    </>
  );
};

export default MapboxDrawMap;
